import Vue from "vue";
import ResourceService from "./resource.service";

class MainClientAccountService extends ResourceService {
  static get resource() {
    return "main-client-account";
  }

  static download(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getClientSites(mainAccountId) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/${mainAccountId}/sites`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default MainClientAccountService;
